// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inventory-link[data-v-35a4ac02] {\n  color: #1976d2; /* Vuetify primary blue color */\n  text-decoration: underline;\n  cursor: pointer;\n}\n.inventory-link[data-v-35a4ac02]:hover {\n  color: #1565c0; /* Darker shade on hover */\n}\n", ""]);
// Exports
module.exports = exports;
